var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-5"},[_c('span',{staticClass:"helvetica-medium billing-period-text",class:_vm.dashboardClass},[_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.header))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }